<template>
  <svg
    width="36px"
    height="36px"
    viewBox="0 0 36 36"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <!-- Generator: sketchtool 51.2 (57519) - http://www.bohemiancoding.com/sketch -->
    <title>2DEAF077-DC82-4A73-80A4-F002E18E46E6</title>
    <desc>Created with sketchtool.</desc>
    <defs />
    <g
      id="vr-view網站icon024"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="網站連結024"
        transform="translate(-1377.000000, -51.000000)"
      >
        <g
          id="link1"
          transform="translate(1377.000000, 51.000000)"
        >
          <g id="link-copy">
            <g
              id="p/4-copy-8"
              fill="#58585A"
              fill-opacity="0.7"
            >
              <g id="Group-20">
                <g id="Group-16">
                  <rect
                    id="Rectangle-4-Copy-5"
                    x="0"
                    y="0"
                    width="36"
                    height="36"
                    rx="5"
                  />
                </g>
              </g>
            </g>
            <g
              id="Group"
              transform="translate(7.000000, 7.000000)"
              :fill="color"
            >
              <g id="Group-9">
                <g id="Group-5">
                  <path
                    id="Fill-1"
                    d="M20.5048324,1.57481908 C18.5111906,-0.524932227 15.2790098,-0.524932227 13.2853679,1.57477428 L9.01875997,6.0684679 C6.95658455,8.24049001 7.1475086,11.7012443 9.01875997,13.6721807 C9.3067626,13.9755119 9.62292738,14.227362 9.95640635,14.4377225 C10.0082638,14.4704303 10.0747554,14.4609316 10.1174666,14.4159471 L10.8236474,13.6721807 C11.1822681,13.294428 11.2004331,12.8718252 11.1762698,12.496492 C11.1732494,12.4492225 11.1481076,12.4069712 11.1087997,12.3838965 C10.945655,12.2882822 10.7519658,12.1481763 10.5423237,11.9431477 C9.60565573,11.0271052 9.49194361,9.12360068 10.3112409,8.10490945 C10.3140061,8.10145945 10.3169414,8.09809906 10.3200044,8.09487308 L14.7714105,3.38535277 C14.7714105,3.38535277 15.8573973,2.22565955 17.1194615,2.37504011 C17.1194615,2.37504011 18.1004146,2.41455831 19.1497737,3.57949374 C20.1991327,4.74442917 19.5618259,6.33237058 19.5618259,6.33237058 C19.5618259,6.33237058 19.3199377,7.07430003 17.8593772,8.59767714 C16.8463056,9.65427357 16.2648977,10.2484354 16.0122466,10.5048109 C15.9769801,10.5406102 15.9634946,10.5933459 15.97681,10.6429901 C16.1219173,11.1829825 16.3495543,12.0625536 16.2426487,13.3115436 C16.2315455,13.4413442 16.3807794,13.5149144 16.4683713,13.4227949 C17.4110801,12.4316141 20.5048324,9.17853187 20.5048324,9.17853187 C22.4983892,7.07878056 22.4983892,3.67457039 20.5048324,1.57481908"
                  />
                  <path
                    id="Fill-3"
                    d="M14.1450852,8.29822725 C13.8355291,7.99832986 13.4952342,7.74988224 13.1363154,7.54285714 C13.0811215,7.54977549 13.0431502,7.55450449 12.9879563,7.56142284 L12.2273106,8.29822725 C11.8348957,8.67825491 11.8260358,9.10474062 11.854921,9.47947005 C11.8574525,9.51257304 11.8750368,9.54265474 11.903018,9.56178967 C12.0909305,9.69026082 12.3638715,9.90394155 12.6292635,10.209794 C13.1543066,10.8149308 13.2296614,11.4133244 13.2296614,11.4133244 C13.2296614,11.4133244 13.5912925,12.8729213 12.5063994,14.0113842 C11.4372372,15.1333393 7.67537026,18.7076311 7.56651932,18.8110561 C7.56480157,18.8126762 7.56371668,18.8137708 7.56213454,18.8154785 C7.51643342,18.8647827 6.67898633,19.7458216 5.24362752,19.6890736 C3.76695236,19.6307055 2.71221022,18.5652356 2.47113792,17.6019209 C2.23002043,16.6386062 2.2903224,16.0255877 2.93822962,15.062273 C3.35704357,14.4396214 5.93221823,12.1397512 6.73521996,11.4287812 C6.76758594,11.4001445 6.78028823,11.3567515 6.7683544,11.3158982 C6.61475162,10.79041 6.34759668,9.90402912 6.47163613,8.62400278 C6.48307271,8.50586536 6.33688336,8.43782031 6.25018232,8.5216287 C5.22622402,9.51191624 1.58875818,13.0301168 1.58875818,13.0301168 C-0.52958606,15.0821523 -0.52958606,18.4090035 1.58875818,20.461039 C3.70719283,22.512987 7.14164805,22.512987 9.26008269,20.461039 L14.1450852,15.7291495 C16.295705,13.6459376 16.1781749,10.2675491 14.1450852,8.29822725"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'SvgWebsite',
  props: {
    color: {
      type: String,
      default () {
        return '#fff'
      }
    }
  }
}
</script>
